import React from "react";
import "./legal.css";
import Accordion from "../../components/accordion/accordion";
import "../../components/accordion/accordion.css"

export const Legal = () => {
  return (
    <div className="legal-page">
      {/* Header Section */}
      <div className="legal-header">
         <h1 className="legal-title">Know Your Rights, Own Your Voice</h1>
        {/* <p className="legal-kicker">
          Understanding the law lets you live with dignity, walk with confidence, and choose without fear.
        </p> */}
        <div className="legal-intro-wrapper">
    <p className="legal-intro">
      Legal awareness isn’t just about sections and clauses—it’s about safety, respect, and freedom.
      For the transgender community, knowing your rights can turn silence into strength and
      discrimination into justice.
    </p>

    <p className="legal-intro legal-intro--muted">
      This space highlights key protections, landmark judgments, and clear next steps to take if your
      rights are ever violated—so you can navigate life and systems with clarity.
    </p>
  </div>
      </div>

      <Accordion title="1. Prohibition Against Discrimination"> 
      <div className="legal-section" id="Discrimination">
<h1>THE TRANSGENDER PERSONS (PROTECTION OF RIGHTS) ACT, 2019
ACT NO. 40 OF 2019
</h1>
<p>An Act to provide for protection of rights of transgender persons and their welfare and for matters
connected therewith and incidentalthereto.
BE it enacted by Parliament in the Seventieth Year of the Republic of India as follows:—</p>
<br>
</br>
  <br></br>
  <p>
    Under the law, <strong>no person or organization</strong> is allowed to discriminate against a transgender person. 
    Here’s what that means in simple terms:
  </p>
  <br></br>
  <ul>
    <li>
       <strong>1.Education:</strong> Cannot be denied admission or treated unfairly in schools, colleges, or any educational services.
    </li>
    <li>
       <strong>2.Employment:</strong> Cannot be treated unfairly, fired, or denied a job because of their gender identity.
    </li>
    <li>
      <strong>3.Healthcare:</strong> Cannot be refused medical treatment or receive unequal care in hospitals or clinics.
    </li>
    <li>
      <strong>4.Public Places & Services:</strong> Cannot be denied access to public services, goods, accommodation, or any benefits meant for all.
    </li>
    <li>
      <strong>5.Freedom of Movement:</strong> Cannot be restricted or treated unfairly while moving freely in public spaces.
    </li>
    <li>
      <strong>6.Housing:</strong> Cannot be denied the right to live, buy, rent, or occupy any property.
    </li>
    <li>
      <strong>7.Holding Office:</strong> Cannot be stopped from running for or holding public or private positions.
    </li>
    <li>
      <strong>8.Institutions or Care Facilities:</strong> Must not be mistreated in government or private facilities where they are under care or custody.
    </li>
  </ul>
  <br></br>
  <p>
    This law ensures that transgender individuals are protected and treated equally in every part of life—just like everyone else.
  </p>
</div>
 </Accordion>

      {/* Section 2: Key Legal Milestones */}
  <Accordion title="2. Recognition of Identity of Transgender Persons">
  <div className="legal-section" id="RECOGNITION" >
  <p>
    Every transgender person has the legal right to be recognized and respected for who they are. The law ensures this through a step-by-step process for identity recognition and documentation.
  </p>
<br></br>
  <ul>
    <li>
       <strong>Right to be Recognized:</strong> Every transgender person has the right to be officially recognized as transgender under the law.
    </li>
    <li>
       <strong>Self-Perceived Gender Identity:</strong> A transgender person has the right to identify their own gender (self-perceived), and this must be respected.
    </li>
  </ul>
<br></br>
  <h3> <b>-Applying for a Certificate of Identity</b></h3>
  <br></br>
  <p>
    A transgender person can apply to the <strong>District Magistrate</strong> for an official certificate of identity.
    This certificate confirms their gender as transgender.
  </p>
  <ul>
    <li>
       The application must be in the prescribed format and include the required documents.
    </li>
    <li>
       For minors, a parent or guardian must apply on their behalf.
    </li>
  </ul>
<br></br>
  <h3> <b>-Issuing the Certificate</b> </h3>
  <ul>
    <li>
       1.The District Magistrate will review the application and issue a certificate identifying the applicant as transgender.
    </li>
    <li>
       2.This certificate will be accepted on all official documents, confirming the person’s gender identity as transgender.
    </li>
    <li>
       3.The certificate grants all legal rights and official recognition under the law.
    </li>
  </ul>
  <br></br>

  <h3> <b>Changing Gender After Surgery</b></h3>
  <p>
    If a transgender person undergoes gender-affirming surgery (to identify as male or female), they can apply for a revised certificate.
  </p>
  <ul>
    <li>
       1. A certificate from the <strong>Medical Superintendent or Chief Medical Officer</strong> is needed as proof of surgery.
    </li>
    <li>
       2. The District Magistrate will then issue a new certificate reflecting the changed gender.
    </li>
    <li>
       3. The person can also request a name change in their birth certificate and other official documents.
    </li>
    <li>
       4. Changing gender and name does <strong>not affect their legal rights</strong> under this Act.
    </li>
  </ul>

  <p>
    This legal recognition process ensures that every transgender person is treated with dignity and is able to live as per their true identity—on paper and in real life.
  </p>
</div>
</Accordion>

<Accordion title="3. Welfare Measures by the Government">
<div className="legal-section" id="welfare-measures">
  <p>
    The law ensures that the government takes active steps to support the transgender community and promote their inclusion in society. Here’s what the government is required to do:
  </p>
<br></br>
  <ul>
    <li>
       <strong>1.Inclusion in Society:</strong> Ensure full and effective participation of transgender persons in all aspects of public life.
    </li>
    <li>
       <strong>2.Welfare & Protection:</strong> Launch and implement welfare schemes to protect the rights and interests of transgender persons.
    </li>
    <li>
       <strong>3.Inclusive Programmes:</strong> Create transgender-friendly schemes that are non-stigmatising and non-discriminatory.
    </li>
    <li>
       <strong>4.Rescue & Rehabilitation:</strong> Provide support systems for transgender persons in need, including rescue and rehabilitation services.
    </li>
    <li>
       <strong>5.Cultural Participation:</strong> Promote transgender participation in cultural and recreational activities across the country.
    </li>
  </ul>
<br></br>
  <p>
    These measures are designed to ensure dignity, equality, and equal access to opportunities for every transgender individual.
  </p>
</div>
</Accordion>

<Accordion title="4. Obligations of Establishments & Persons">
<div className="legal-section" id="obligations-rights">
  <h3> <b>-Non-Discrimination in Employment</b></h3>
  <p>
    No establishment shall discriminate against any transgender person in any aspect of employment, including:
  </p>
  <ul>
    <li> 1. Recruitment</li>
    <li> 2. Promotion</li>
    <li> 3. Transfers or other work-related matters</li>
  </ul>
<br></br>
  <h3> <b>-Responsibilities of Establishments</b></h3>
  <br></br>
  <p>
    All establishments must:
  </p>
  <ul>
    <li> 1. Comply with the Transgender Persons (Protection of Rights) Act</li>
    <li> 2. Provide prescribed facilities and support for transgender employees</li>
  </ul>
<br></br>
  <h3> <b>-Grievance Redressal Mechanism</b></h3>
  <p>
    Every establishment is required to:
  </p>
  <ul>
    <li> 1. Appoint a <strong>complaint officer</strong></li>
    <li> 2. Address and resolve any grievances related to violation of transgender rights</li>
  </ul>
  </div>
  </Accordion>

<Accordion title="5. Right of Residence">
  <div className="legal-section" id="right-of-residence">
  <h3> <b>-Protection from Family Separation</b></h3>
  <ul>
    <li> A child cannot be separated from their family for being transgender, unless ordered by a court in their best interest.</li>
  </ul>
<br></br>
  <h3><b>- Rights of Transgender Persons at Home</b></h3>
  <ul>
    <li> 1. Right to live in the family home</li>
    <li> 2. No exclusion from the household</li>
    <li> 3. Equal access to household facilities without discrimination</li>
  </ul>
<br></br>
  <h3> <b>-If Family Support is Not Available</b></h3>
  <p>
    If the parent or family cannot care for a transgender person, a court may order them to be placed in a rehabilitation centre for proper care and support.
  </p>
</div>
</Accordion>

<Accordion title="6. National Council for Transgender Persons">
<div className="legal-section" id="national-council">
  <h3><b>Section 16 - Constitution of the Council</b></h3>
  <br></br>
  <p>
    (1) The Central Government will officially create the <strong>National Council for Transgender Persons</strong> through a notification. This council will have specific powers and responsibilities under the Act.
  </p>

  <p>(2) The National Council will consist of the following members:</p>
  <br></br>
  <ul>
    <li>(a) The Union Minister of Social Justice and Empowerment – <strong>Chairperson (ex officio)</strong></li>
  
    <li>(b) The Minister of State of Social Justice and Empowerment – <strong>Vice-Chairperson (ex officio)</strong></li>

    <li>(c) Secretary of the Ministry of Social Justice and Empowerment - 
      
      <strong>Member (ex officio)</strong></li>
    <li>(d) One representative each from the following ministries/departments, not below Joint Secretary rank – <strong>Members (ex officio)</strong>:
    
      <ul>
        <li>Health and Family Welfare</li>
        <li>Home Affairs</li>
        <li>Housing and Urban Affairs</li>
        <li>Minority Affairs</li>
        <li>Human Resource Development</li>
        <li>Rural Development</li>
        <li>Labour and Employment</li>
        <li>Legal Affairs</li>
        <li>Pensions and Pensioners Welfare</li>
        <li>NITI Aayog (Planning Commission)</li>
      </ul>
    </li>

    <li>(e) One representative each from:
      <ul>
        <li>National Human Rights Commission</li>
        <li>National Commission for Women</li>
      </ul>
      (Not below the rank of Joint Secretary) – <strong>Members (ex officio)</strong>
    </li>
    
    <li>(f) One representative from each region (North, South, East, West, North-East), representing State Governments and Union Territories, <strong>nominated by the Central Government</strong> – <strong>Members (ex officio)</strong></li>
    
    <li>(g) Five representatives from the transgender community, one from each region (North, South, East, West, North-East), <strong>nominated by the Central Government</strong> – <strong>Members</strong></li>
    <li>
      (h) Five experts from NGOs or associations working for transgender welfare, <strong>nominated by the Central Government</strong> – <strong>Members</strong></li>
    
    <li>(i) Joint Secretary in the Ministry of Social Justice and Empowerment responsible for transgender welfare – <strong>Member Secretary (ex officio)</strong></li>
  </ul>
<br></br>
  <p>(3) Members of the Council (excluding ex officio members) will serve a term of <strong>three years</strong> from the date of their nomination.</p>
<br></br>
  <h3><b>Section 17 – Functions of the Council</b></h3>
  <p>The National Council shall perform the following functions:</p>
  <ul>
    <li>(a) Advise the Central Government in making <strong>policies, programs, laws, and projects</strong> for transgender persons</li>
    <li>(b) Monitor and evaluate the effectiveness of these policies and programs</li>
    <li>(c) Review and coordinate activities of all government and non-government organizations related to transgender issues</li>
    <li>(d) Address and resolve the <strong>grievances of transgender persons</strong></li>
    <li>(e) Perform other functions as assigned by the Central Government</li>
  </ul>
</div>
 </Accordion>

{/* Section: Education, Social Security and Health */}
      <Accordion title="7. Education, Social Security and Health of Transgender Persons">
      <div className="legal-section" id="health-edu">
        <p>
          <strong>Inclusive Education (Section 13): </strong>  
          Every school, college or university that is either funded or recognized by the Government must make sure transgender persons are given equal education opportunities. This includes allowing them to participate in sports, recreation, and other leisure activities without any discrimination.
        </p>
<br></br>
        <p>
          <strong>Vocational Training and Self-Employment (Section 14):</strong>  
          The Government must create special schemes and programs to help transgender persons get jobs or start their own businesses. This includes providing them with vocational (skill-based) training.
        </p>
<br></br>
        <p>
          <strong>Healthcare Facilities (Section 15):</strong>  
          The Government must take steps to ensure the health and well-being of transgender persons through the following:
        </p>
<br></br>
        <ul>
          <li>
            1. Setting up special centres for HIV testing and monitoring, following guidelines from the National AIDS Control Organisation.
          </li>
          <li>
            2. Providing medical care, including sex reassignment surgeries and hormone therapies.
          </li>
          <li>
            3. Offering counselling support before and after these medical procedures.
          </li>
          <li>
            4. Publishing a Health Manual on sex reassignment surgery that follows international standards set by the World Professional Association for Transgender Health.
          </li>
          <li>
            5. Reviewing medical education to include transgender health topics so doctors can better address their needs.
          </li>
      
          <li>
            6. Making sure hospitals and healthcare centres are welcoming and accessible to transgender persons.
          </li>
          <li>
            7. Covering medical expenses through an insurance scheme. This should include costs of surgery, hormone therapy, laser therapy, and any other health needs of transgender persons.
          </li>
        </ul>
      </div>
</Accordion>

<Accordion title="8. Offences and Penalties">
<div className="legal-section" id="penalty">
  <p>
    The law strictly protects transgender individuals from harm, abuse, and discrimination. Anyone who violates these rights can face serious legal consequences. Under the Transgender Persons (Protection of Rights) Act, the following acts are considered offences:
  </p>
  <br></br>
  <p>
    (a) If anyone compels or entices a transgender person to engage in forced or bonded labour — which means making someone work against their will, without pay, or under threat — they are committing a punishable offence. However, this does not include compulsory services imposed by the government for public purposes.
  </p>
  <br></br>
  <p>
    (b) If a transgender person is denied the right to access public places — like parks, restaurants, hospitals, educational institutions, public transport, etc. — or is obstructed from using them when others are allowed to, this too is a punishable act.
  </p>
  <br></br>
  <p>
    (c) Forcing a transgender person to leave their home, village, or any place where they reside is a crime. Everyone has the right to live where they feel safe and accepted, and no one can force them to leave just because of their gender identity.
  </p>
  <br></br>
  <p>
    (d) Any act that harms or threatens the life, safety, physical or mental well-being of a transgender person is strictly prohibited. This includes:
    <ul>
      <li>Physical abuse (like hitting or injuring them)</li>
      <li>Sexual abuse (any unwanted sexual act)</li>
      <li>Verbal or emotional abuse (insults, threats, humiliation)</li>
      <li>Economic abuse (not allowing them access to money or basic needs)</li>
    </ul>
  </p>
  <br></br>
  <p>
    Anyone found guilty of committing any of the above offences will be punished with imprisonment for a term not less than six months, which can be extended up to two years, and they may also have to pay a fine. These laws exist to ensure that transgender individuals can live with dignity, free from fear, and with full protection under the law.
  </p>
</div>
</Accordion>

<Accordion title="Miscellaneous">
<div className="legal-section" id="misc">
  <p> 
    The Central Government shall, from time to time and after due appropriation made by Parliament by law, credit such sums to the National Council as may be necessary for carrying out the purposes of this Act. The provisions of this Act are in addition to, and not in derogation of, any other law in force. No suit, prosecution, or other legal proceeding shall lie against the appropriate Government, any local authority, or any Government officer for anything done or intended to be done in good faith under this Act or any rules made under it.
    <br /><br />
    The appropriate Government may, by notification and subject to prior publication, make rules for implementing the provisions of this Act. Such rules may include: (a) the form and manner of applications under Section 5; 
    (b) the procedure, form, manner, and period for issuing identity certificates under Section 6(1); (c) the form and manner of applications under Section 7(1); (d) the form, period, and manner of issuing revised certificates under Section 7(2); (e) welfare measures under Section 8(2); (f) facilities under Section 10; (g) other functions of the National Council under Section 17(e); and (h) any other matter required or permitted to be prescribed.
    <br /><br />
    Every rule made by the Central Government under Section 22(1) shall be laid before both Houses of Parliament for a total of thirty days (which may span one or more sessions). If both Houses agree to modify or annul the rule before the end of the session immediately following that period, the rule shall only take effect in its modified form or shall be void, without affecting previous actions taken under it. Similarly, rules made by the State Government shall be laid before the respective State Legislature—before both Houses where applicable or the single House where the Legislature is unicameral.
    <br /><br />
    If any difficulty arises in giving effect to the provisions of this Act, the Central Government may, by order in the Official Gazette, make provisions not inconsistent with the Act to remove the difficulty—provided that no such order shall be made after two years from the commencement of the Act. Every such order shall be laid before both Houses of Parliament as soon as possible after it is made.
  </p>
</div>
</Accordion>
    </div>
  );
};

export default Legal;

